import styled from "@emotion/styled";
import { type Widget, type WidgetSizeDefinition } from "@repo/api";
import { Button, LightMode, Text, Variables } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateLabel } from "@repo/ui";
import { useState } from "react";

const WidgetContainer = styled.div`
  padding: ${Variables.space100};
  height: 100%;
  background-color: ${LightMode.colourStaticWhite};
  border-radius: ${Variables.radiusM};
  border: ${Variables.thicknessThin} dashed ${LightMode.colourNeutral7};

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: ${Variables.space75};
`;

export const WidgetBox = ({
  widget,
  onAddWidget,
}: {
  widget?: Widget;
  onAddWidget: (
    w: Widget,
    appSize: WidgetSizeDefinition,
    appSettings: Record<string, object>
  ) => Promise<void>;
}) => {
  const [loading, setLoading] = useState(false);
  if (!widget) {
    return null;
  }

  return (
    <WidgetContainer key={widget.name}>
      <Text textStyle="Heading.XS">{translateLabel(widget.name)}</Text>
      <Button
        text={t("action.add")}
        size="small"
        loading={loading}
        onClick={() => {
          setLoading(true);
          onAddWidget(widget, widget.sizeDefinition[0], {}).finally(() => {
            setLoading(false);
          });
        }}
      />
    </WidgetContainer>
  );
};
